export const REMOVE_ENGAGEMENTS_COMMENT_REQUEST = 'REMOVE_ENGAGEMENTS_COMMENT_REQUEST';
export const REMOVE_ENGAGEMENTS_COMMENT_SUCCESS = 'REMOVE_ENGAGEMENTS_COMMENT_SUCCESS';
export const REMOVE_ENGAGEMENTS_COMMENT_FAILURE = 'REMOVE_ENGAGEMENTS_COMMENT_FAILURE';
